import { Box, Link, Typography } from '@achieve/ascend'

import { useState } from 'react'
import { Grid, styled, Tooltip, tooltipClasses } from '@mui/material'
import { X } from 'react-feather'
import AchieveLogoSVGBlack from 'components/Svgs/AchieveLogoSVGBlack'

import { FloatingBadge } from 'components/DebtAssessment/FloatingBadge'
import AchieveLogoSVG from 'components/Svgs/AchieveLogoSVG'
import Ok from 'components/Svgs/Ok'

export const DatTable = ({
  firstColumnLabel = 'Current',
  lastColumnLabel = 'Est. Savings',
  labelFirstRow = 'Est. monthly payment',
  labelSecondRow = 'Est. total debt cost',
  tooltipLabelSecondRow = 'Your starting debt amount and added interest built up over time',
  monthlyCurrent = '$750',
  monthlyAchieve = '$540',
  monthlySavings = '$210',
  totalCurrent = '$53,000',
  totalAchieve = '$20,000',
  totalSavings = '$33,000',
  badge = true,
  estSavingsColumn = true,
  estMonthlySavingsBottom = true,
  variation = 'line',
  labelThirdRow,
  labelFirstRowSup,
  labelSecondRowSup,
  labelThirdRowSup,
  currentTime = '27 yr',
  achieveTime = '2-4 yr',
}) => {
  const [open, setOpen] = useState(false)
  const handleTooltipClose = () => {
    setOpen(false)
  }
  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} placement="bottom" classes={{ popper: className }} />
  ))(({ theme, width }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: `${theme.ascend.colors.neutral[0]}`,
      border: `1px solid ${theme.ascend.colors.neutral[150]}`,
      borderRadius: 10,
      maxWidth: width,
      color: `${theme.ascend.colors.neutral[975]}`,
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
  }))

  return variation == 'bars' ? (
    <div className="max-w-md mx-auto rounded-3xl overflow-hidden border-[#DFE5EB] border-solid border-2">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b-2 border-[#DFE5EB]">
            <th className="p-4 w-1/3">{''}</th>
            <th className="p-4 w-1/3">
              <div className="flex items-center justify-center">
                <AchieveLogoSVG title="Achieve Logo" alt="Achieve Logo" height="20" width="80" />
              </div>
            </th>
            <th className="p-4 w-1/3">
              <Typography variant="labelMd" mobilevarian="labelSm">
                {firstColumnLabel}
              </Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-[#DFE5EB] border-b-2 border-t-2 border border-solid border-r-0 border-l-0 ">
            <td className="p-4 text-gray-600">
              <div>
                <Typography variant="labelSm" className="text-gray-500">
                  {labelFirstRow}
                  {labelFirstRowSup && <sup>{labelFirstRowSup}</sup>}
                </Typography>
              </div>
            </td>
            <td className="p-4 bg-blue-50 text-left">
              <Typography
                variant="labelSm"
                className="flex items-center justify-between w-full text-[#154199]"
              >
                {monthlyAchieve}/mo
                <Ok className="h-5 w-5 " />
              </Typography>
            </td>
            <td className="p-4 text-center text-gray-800">
              <Typography variant="labelSm">{monthlyCurrent}/mo</Typography>
            </td>
          </tr>
          <tr className="border-[#DFE5EB] border-b-2 border border-solid border-r-0 border-l-0 border-t-0 ">
            <td className="p-4 text-gray-600">
              <div>
                <Typography variant="labelSm" className="text-gray-500">
                  {labelSecondRow}
                  {labelSecondRowSup && <sup>{labelSecondRowSup}</sup>}
                </Typography>
              </div>
            </td>
            <td className="p-4 bg-blue-50 text-left">
              <Typography
                variant="labelSm"
                className="flex items-center justify-between w-full text-[#154199]"
              >
                {achieveTime}
                <Ok className="h-5 w-5 " />
              </Typography>
            </td>
            <td className="p-4 text-center text-gray-800">
              <Typography variant="labelSm">{currentTime}</Typography>
            </td>
          </tr>

          <tr>
            <td className="p-4 text-gray-600">
              <div>
                <Typography variant="labelSm" className="text-gray-500">
                  {labelThirdRow}
                  {labelThirdRowSup && <sup>{labelThirdRowSup}</sup>}
                </Typography>
              </div>
            </td>
            <td className="p-4 bg-blue-50 text-left">
              <Typography
                variant="labelSm"
                className="flex items-center justify-between w-full text-[#154199]"
              >
                {totalAchieve}
                <Ok className="h-5 w-5" />
              </Typography>
            </td>
            <td className="p-4 text-center text-gray-800">
              <Typography variant="labelSm">{totalCurrent}</Typography>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    <table className="border-collapse w-full">
      <tbody>
        <tr className="flex flex-wrap w-full text-center">
          <td className="flex flex-col flex-1 h-[30px] p-0" />
          <th className="flex flex-col flex-1 h-[30px]  rounded-tl-lg lg:rounded-none p-0 bg-[rgb(248,249,252)]">
            <div className="h-full border-l border-[rgb(51,0,255)] flex items-center justify-center">
              <Typography variant="bodyXs" fontWeight="medium" className="text-gray-500">
                {firstColumnLabel}
              </Typography>
            </div>
          </th>
          <th className="flex flex-col flex-1 h-[30px] bg-[rgb(51,0,255)] justify-center items-center p-0">
            <div className="h-full flex justify-center items-center border-l border-r border-blue-200">
              <AchieveLogoSVGBlack />
            </div>
          </th>
          {estSavingsColumn && (
            <th className="relative flex flex-col flex-1 h-[30px] bg-green-300 justify-center items-center p-0">
              {badge && (
                <div className="absolute -top-3 -right-3">
                  <FloatingBadge />
                </div>
              )}
              <Typography variant="bodyXs" fontWeight="medium" className="text-white">
                {lastColumnLabel}
              </Typography>
            </th>
          )}
        </tr>
        <tr className="flex flex-wrap w-full text-center">
          <th className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white p-0 place-content-center">
            <div className="flex justify-center items-center text-right lg:text-left w-full">
              <Typography variant="bodyXs" className="text-gray-500">
                {labelFirstRow}
                {labelFirstRowSup && <sup>{labelFirstRowSup}</sup>}
              </Typography>
            </div>
          </th>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t  border-r-0 border-b-0 border-solid lg:border-l border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold">
                {monthlyCurrent}
              </Typography>
            </div>
          </td>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t border-l  border-r-0 border-b-0 border-solid border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold">
                {monthlyAchieve}
              </Typography>
            </div>
          </td>
          {estSavingsColumn && (
            <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-green-100 border-l border-t border-gray-300 p-0">
              <div className="flex justify-center items-center h-full">
                <Typography variant="bodySm" fontWeight="bold" className="text-green-500">
                  {monthlySavings}
                </Typography>
              </div>
            </td>
          )}
        </tr>
        <tr className="flex flex-wrap w-full text-center">
          <th className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t p-0 place-content-center">
            <div className="flex justify-center items-center text-right lg:text-left w-full">
              {tooltipLabelSecondRow ? (
                <div className="text-gray-500 text-left">
                  <HtmlTooltip
                    title={
                      <Grid
                        container
                        wrap="nowrap"
                        direction="row-reverse"
                        justifyContent="space-between"
                        alignItems="start"
                      >
                        <Grid item>
                          <X
                            onClick={handleTooltipClose}
                            className="text-gray-400 cursor-pointer w-6 h-6 -translate-y-2 hover:text-gray-300"
                          />
                        </Grid>
                        <Grid item>
                          {labelSecondRow && (
                            <Box component="span" display={'flex'}>
                              <Typography variant="labelSm" fontWeight="bold" className="mb-1">
                                {labelSecondRow}
                              </Typography>
                            </Box>
                          )}
                          {tooltipLabelSecondRow && (
                            <Box component="span">
                              <Typography component="div" variant="bodyXs">
                                {tooltipLabelSecondRow}
                              </Typography>
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    }
                    PopperProps={{ disablePortal: true }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    width={300}
                  >
                    <Link
                      onClick={open ? handleTooltipClose : handleTooltipOpen}
                      className="text-gray-500 underline cursor-pointer text-xs"
                    >
                      {labelSecondRow} {labelSecondRowSup && <sup>{labelSecondRowSup}</sup>}
                    </Link>
                  </HtmlTooltip>
                </div>
              ) : (
                <Typography variant="bodyXs" className="text-gray-500">
                  {labelSecondRow} {labelSecondRowSup && <sup>{labelSecondRowSup}</sup>}
                </Typography>
              )}
            </div>
          </th>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t border-r-0 border-b-0 border-solid lg:border-l border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold">
                {totalCurrent}
              </Typography>
            </div>
          </td>
          <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-white border-t border-l  border-r-0 border-b-0 border-solid border-gray-300 p-0">
            <div className="flex justify-center items-center h-full">
              <Typography variant="bodySm" fontWeight="bold">
                {totalAchieve}
              </Typography>
            </div>
          </td>
          {estSavingsColumn && (
            <td className="flex flex-col flex-1 h-[50px] lg:h-[95px] bg-green-100 border-l border-t border-gray-300 p-0">
              <div className="flex justify-center items-center h-full">
                <Typography variant="bodySm" fontWeight="bold" className="text-green-500">
                  {totalSavings}
                </Typography>
              </div>
            </td>
          )}
        </tr>

        {estMonthlySavingsBottom && (
          <tr>
            <td colSpan={4} className="bg-green-300 h-[50px] lg:h-[95px] flex place-content-center">
              <div className="flex items-center gap-2 px-2">
                {badge && <FloatingBadge />}
                <Typography variant="bodySm" fontWeight="regular" className="text-white text-sm">
                  Your estimated savings could be <strong>{monthlySavings}/month</strong>
                </Typography>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
